import { render, staticRenderFns } from "./ThreadDisplay.vue?vue&type=template&id=4ff9b3b8&scoped=true&"
import script from "./ThreadDisplay.vue?vue&type=script&lang=js&"
export * from "./ThreadDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ThreadDisplay.vue?vue&type=style&index=0&id=4ff9b3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff9b3b8",
  null
  
)

export default component.exports